import React, {
  useMemo,
  useState,
} from 'react';

import InvoiceDocument from './InvoiceDocument.jsx';

import './InvoiceFieldQuiz.css';


const InvoiceFieldQuiz = ({
  content,
  invoice,
}) => {
  const [selectedAnswer, setSelectedAnswer] =
    useState('');

  const [isChecked, setIsChecked] =
    useState(false);


  /* =====================================================
     DATE FACTURA
  ===================================================== */

  const invoiceData =
    invoice ||
    content?.invoice ||
    null;


  /* =====================================================
     DATE QUIZ
  ===================================================== */

  const question =
    content?.question ||
    'Identifica informatia corecta din factura.';


  const options =
    Array.isArray(
      content?.options
    )
      ? content.options
      : [];


  const correctAnswer =
    content?.correctAnswer;


  const explanation =
    content?.explanation;


  const highlightAfterAnswer =
    content?.highlightAfterAnswer ||
    '';


  /* =====================================================
     ESTE CORECT?
  ===================================================== */

  const isCorrect =
    useMemo(() => {
      if (
        !isChecked ||
        !selectedAnswer
      ) {
        return false;
      }

      return (
        selectedAnswer ===
        correctAnswer
      );
    }, [
      isChecked,
      selectedAnswer,
      correctAnswer,
    ]);


  /* =====================================================
     SELECTARE
  ===================================================== */

  const handleSelect = (
    option
  ) => {
    if (isChecked) {
      return;
    }

    setSelectedAnswer(
      option
    );
  };


  /* =====================================================
     VERIFICARE
  ===================================================== */

  const handleCheck = () => {
    if (!selectedAnswer) {
      return;
    }

    setIsChecked(true);
  };


  /* =====================================================
     RESET
  ===================================================== */

  const handleReset = () => {
    setSelectedAnswer('');
    setIsChecked(false);
  };


  /* =====================================================
     CLASA OPTIUNE
  ===================================================== */

  const getOptionClassName = (
    option
  ) => {
    const classes = [
      'invoice-field-option',
    ];


    if (
      !isChecked &&
      selectedAnswer === option
    ) {
      classes.push(
        'is-selected'
      );
    }


    if (isChecked) {
      if (
        option ===
        correctAnswer
      ) {
        classes.push(
          'is-correct'
        );
      } else if (
        option ===
        selectedAnswer
      ) {
        classes.push(
          'is-incorrect'
        );
      }
    }


    return classes.join(' ');
  };


  if (!content) {
    return null;
  }


  return (
    <div className="invoice-field-quiz">


      {/* =================================================
          DOCUMENT
      ================================================= */}

      {invoiceData && (
        <div className="invoice-field-document">

          <InvoiceDocument
            invoice={
              invoiceData
            }
            highlightField={
              isChecked
                ? highlightAfterAnswer
                : ''
            }
          />

        </div>
      )}


      {/* =================================================
          QUIZ
      ================================================= */}

      <div className="invoice-field-question-card">

        <span className="invoice-field-eyebrow">
          CITESTE FACTURA
        </span>


        <h2>
          {question}
        </h2>


        {content.context && (
          <p className="invoice-field-context">
            {content.context}
          </p>
        )}


        {/* ===============================================
            OPTIUNI
        =============================================== */}

        <div className="invoice-field-options">

          {options.map(
            (
              option,
              index
            ) => (
              <button
                key={
                  `${option}-${index}`
                }
                type="button"
                className={
                  getOptionClassName(
                    option
                  )
                }
                onClick={() =>
                  handleSelect(
                    option
                  )
                }
                disabled={
                  isChecked
                }
              >

                <span className="invoice-field-option-letter">
                  {
                    String.fromCharCode(
                      65 + index
                    )
                  }
                </span>

                <span>
                  {option}
                </span>

              </button>
            )
          )}

        </div>


        {/* ===============================================
            FEEDBACK
        =============================================== */}

        {isChecked && (
          <div
            className={[
              'invoice-field-feedback',

              isCorrect
                ? 'is-correct'
                : 'is-incorrect',
            ]
              .filter(Boolean)
              .join(' ')}
          >

            <strong>
              {
                isCorrect
                  ? 'Corect!'
                  : 'Mai verifica factura.'
              }
            </strong>


            {explanation && (
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    explanation,
                }}
              />
            )}

          </div>
        )}


        {/* ===============================================
            ACTIUNI
        =============================================== */}

        <div className="invoice-field-actions">

          {!isChecked ? (
            <button
              type="button"
              className="invoice-field-check"
              onClick={
                handleCheck
              }
              disabled={
                !selectedAnswer
              }
            >
              Verifica
            </button>
          ) : (
            <button
              type="button"
              className="invoice-field-reset"
              onClick={
                handleReset
              }
            >
              Incearca din nou
            </button>
          )}

        </div>

      </div>

    </div>
  );
};


export default InvoiceFieldQuiz;